'use strict';

(function (angular) {
  angular.module('zp').directive('socialShares', socialShares);

  /**@ngInject */
  function socialShares($window) {
    return {
      restrict: 'E',
      link: link,
      scope: {
        subject: '@',
        hashTags: '@'
      },
      templateUrl: 'app/shared/social.shares.html'
    };

    function link(scope) {
      scope.url = $window.location.href;
    }
  }
})(window.angular);